import KeyMirror from 'keymirror';

export const FOXORDER_V2 = "foxorder v2"

export const AppActionsType = KeyMirror({
    "SET_FIRUSER": null,
    "SET_RESTAURANT": null,
    "SET_ESTABLISHMENT": null,
    "SET_POPINA_CARTE": null,
    "APP_START": null,
    "APP_END": null,
    "SET_DELIVEROO_STORE": null,
    "SET_UBEREATS_STORE": null,
    "UPDATE_STORE": null,
});

export const AuthenticationActionsType = KeyMirror({
    "LOGGED": null,
    "SELECT_ESTABLISHMENT": null,
    "LOGGED_FIR": null,
});

export const PopinaAtionType = KeyMirror({
    "SET_POPINA_CARTE": null
});

export const StoreActionType = KeyMirror({
    "SET_UBEREATS_SERVICE": null,
    "SET_FOXORDER_V2_SERVICE": null,
    "SET_DELIVEROO_SERVICE": null,
    "SET_HUBRISE_SERVICE": null,
    "LOAD_CURRENT_UBEREATS_STORE": null,
    "SET_KEYTCHENS_SERVICE": null,
    "SET_FOXORDER_V2_SHOPS": null,
    "SET_OBYPAY_SERVICE": null,
});

export const DeliveraActionType = KeyMirror({
    "UPDATE_MENU": null
});

export const ImageActionType = KeyMirror({
    'ADD_IMAGE_URL': null
});

export interface ActionInterface {
    type: string
    data: any
}

export const ALERT_SEVERITY = KeyMirror({
    success: null,
    info: null,
    warning: null,
    error: null
});